// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3_wUq","legacyBtn":"MutateMid_legacyBtn__1tgER"};